import { Icon, Typography } from '@mui/material'
import colors from 'styles/colors'
import InCardStack from './container/InCardStack'
import { useTranslation } from 'react-i18next'
import RowStack from './container/RowStack'
import { IconContainer } from './Icons'
import CircleIcon from '@mui/icons-material/Circle'

const RadarGraphLegend = ({ displayOthersRating = true, colStyle = false }) => {
  const { t } = useTranslation()

  const LabelGroup = ({ label, color }) => (
    <RowStack spacing={4}>
      <IconContainer icon={<CircleIcon />} size={16} style={{ color: color }} />
      <Typography variant='body1KindaSmall' color='primary'>
        {label}
      </Typography>
    </RowStack>
  )

  return (
    <>
      {colStyle ? (
        <InCardStack spacing={8}>
          <LabelGroup
            label={t('goalsArea.selfRating')}
            color={colors.Teal400}
          />
          {displayOthersRating && (
            <LabelGroup
              label={t('goalsArea.othersRating')}
              color={colors.MidnightTeal400}
            />
          )}
        </InCardStack>
      ) : (
        <InCardStack>
          <Typography color='primary' fontStyle='italic'>
            {t('goalsArea.clickBehaviours')}
          </Typography>
          <InCardStack
            direction='row'
            sx={{ marginTop: '5px !important' }}
            spacing={15}>
            <Typography fontWeight='bold' color={colors.Teal400}>
              <Icon style={{ paddingRight: '20px', fontSize: '10px' }}>
                circle
              </Icon>
              {t('goalsArea.selfRating')}
            </Typography>
            {displayOthersRating ? (
              <Typography fontWeight='bold' color={colors.MidnightTeal400}>
                <Icon
                  style={{
                    paddingRight: '20px',
                    fontSize: '10px'
                  }}>
                  circle
                </Icon>
                {t('goalsArea.othersRating')}
              </Typography>
            ) : null}
          </InCardStack>
        </InCardStack>
      )}
    </>
  )
}

export default RadarGraphLegend
